import React from 'react';
import patients from '../../../../../../services/patients';
import users from '../../../../../../services/users/index';
import { format } from 'date-fns';

export default class MovementTableItem extends React.Component {
    state = {
        user: null,
        patient: null,
        date: ""
    }

    componentWillReceiveProps(nextProps) {
        let {patient, user} = nextProps.movement;
        let date = format(
            new Date(nextProps.movement.date),
            'DD/MM/YYYY'
        )
        patients.findOne({_id: patient}, (err, patient) => {
            this.setState({patient: patient, date: date})
        })

        users.findOne({_id: user}, (err, user) => {
            this.setState({user: user})
        })
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    render() {
        if(!this.state.user || !this.state.patient)
            return <tr><td><button className="button is-loading">Loading</button></td></tr>

        return (
            <tr>
                <td>${this.props.movement.pay}</td>
                <td>{`${this.state.patient.name} ${this.state.patient.lastname}`}</td>
                <td>{this.state.date}</td>
                <td>{this.state.user.userName}</td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/movements/components/movement-table-item/index.js